// extracted by mini-css-extract-plugin
module.exports = {"recordWrapper":"RecordPanel_recordWrapper__30k9e","stopWatch":"RecordPanel_stopWatch__3TXAm"};